import { Injectable } from '@angular/core';
import {ParentService} from '../../pages/A2-utils/ParentClass/ParentService';
import {constant} from '../../app.constants';
import {Http, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class RiderNotesInformationService extends ParentService {
  public changeNotes = new BehaviorSubject<boolean>(false);
  changeNotes$ = this.changeNotes.asObservable();

  constructor(private http: Http) {
    super();
  }



  /**
   * @description get notes rider
   * @param id = riderid
   * @returns {Observable<any>}
   */
  public get(id: number) {
    return this.http.get(`${constant.URL_RIDER_NOTES}/list/${id}`, this.getHeader())
      .map(resp => resp.json());
  }

  /**
   * @description delete notes
   * @param id = noteid
   * @returns {Observable<any>}
   */
  public delete(id: number) {
    return this.http.delete(`${constant.URL_RIDER_NOTES}/${id}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @description create notes
   * @param data = info note
   * @returns {Observable<any>}
   */
  public post(data: any) {
    const body = JSON.stringify(data);
    return this.http.post(constant.URL_RIDER_NOTES, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description modify the information of the note
   * @param data = info note
   * @returns {Observable<any>}
   */
  public put(data) {
    const body = JSON.stringify(data);
    return this.http.put(constant.URL_RIDER_NOTES, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/rider-notes-information.service.ts